import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component, Children } from 'react';
import StackView from '../StackView';
import { generateId } from '../utils';
import Tab from './Tab';
import TabList, { TABLIST_DISPLAY_NAME } from './TabList';
import TabPanel from './TabPanel';
import TabPanels, { TABPANELS_DISPLAY_NAME } from './TabPanels';

var Tabs = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Tabs, _Component);

  function Tabs() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "id", generateId('tabs'));

    _defineProperty(_assertThisInitialized(_this), "state", {
      activeIndex: _this.props.defaultActiveIndex
    });

    _defineProperty(_assertThisInitialized(_this), "setTabList", function (node) {
      if (node) {
        _this.tabList = node.querySelector('[role="tablist"]');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setActiveIndex", function (activeIndex) {
      if (_this.props.onChange) {
        _this.props.onChange(activeIndex);
      }

      if (_this.props.activeIndex === null) {
        _this.setState({
          activeIndex: activeIndex
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getActiveIndex", function () {
      return _this.props.activeIndex === null ? _this.state.activeIndex : _this.props.activeIndex;
    });

    _defineProperty(_assertThisInitialized(_this), "getNextTab", function (startIndex, direction) {
      var tabCount = _this.tabList.children.length;
      var nextIndex = startIndex + direction;

      if (nextIndex < 0) {
        nextIndex = tabCount - 1;
      } else if (nextIndex >= tabCount) {
        nextIndex = 0;
      }

      var nextTab = _this.tabList.children[nextIndex];

      if (nextTab.getAttribute('aria-disabled') === 'true') {
        return _this.getNextTab(nextIndex, direction);
      } else {
        return nextTab;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "moveTabFocus", function (direction) {
      var nextTab = _this.getNextTab(_this.getActiveIndex(), direction);

      if (nextTab) {
        nextTab.focus();
      }
    });

    return _this;
  }

  var _proto = Tabs.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        activeIndex = _this$props.activeIndex,
        children = _this$props.children,
        defaultActiveIndex = _this$props.defaultActiveIndex,
        onChange = _this$props.onChange,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["activeIndex", "children", "defaultActiveIndex", "onChange"]);

    return /*#__PURE__*/React.createElement(StackView, _extends({
      innerRef: this.setTabList
    }, restProps), Children.map(children, function (child, index) {
      if (child && child.type.displayName === TABLIST_DISPLAY_NAME) {
        return /*#__PURE__*/React.cloneElement(child, {
          id: _this2.id,
          activeIndex: _this2.getActiveIndex(),
          moveTabFocus: _this2.moveTabFocus,
          setActiveIndex: _this2.setActiveIndex
        });
      } else if (child && child.type.displayName === TABPANELS_DISPLAY_NAME) {
        return /*#__PURE__*/React.cloneElement(child, {
          id: _this2.id,
          activeIndex: _this2.getActiveIndex()
        });
      } else {
        return child;
      }
    }));
  };

  return Tabs;
}(Component);

_defineProperty(Tabs, "Tab", Tab);

_defineProperty(Tabs, "TabList", TabList);

_defineProperty(Tabs, "TabPanel", TabPanel);

_defineProperty(Tabs, "TabPanels", TabPanels);

_defineProperty(Tabs, "defaultProps", {
  activeIndex: null,
  defaultActiveIndex: 0
});

export default Tabs;